"use client";

import { Component, type ReactNode } from "react";
import { JsonFallback } from "./JsonFallback";
import type { RenderContext } from "./types";

interface Props {
  value: unknown;
  ctx: RenderContext;
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

/** If a renderer throws during render, fall back to the raw JSON subtree for
 *  that value only — one bad renderer never blanks the whole result. */
export class ValueErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return <JsonFallback value={this.props.value} ctx={this.props.ctx} />;
    }
    return this.props.children;
  }
}
